import { render, staticRenderFns } from "./aheader.vue?vue&type=template&id=271f3c38"
import script from "./aheader.vue?vue&type=script&lang=js"
export * from "./aheader.vue?vue&type=script&lang=js"
import style0 from "./aheader.vue?vue&type=style&index=0&id=271f3c38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports